<template>
  <div id="index">
    <div id="containerBox">
      <div id="header1">
        <div>
          {{ now1 }}
        </div>
      </div>

      <div id="leftPart">
        <div id="content1">
          <img src='/images/web_img/TOG_Logo_500X70_3.jpg' alt="">
          <!--                    <img src='/images/web_img/book.gif' alt="">-->
        </div>

        <div id="content2">
          <ul>
            <li>
              <router-link to="/">Home</router-link>
            </li>
            <li>
              <router-link to="/video">Video<!--分享视频--></router-link>
            </li>  <!-- /video -->
            <li><a href="http://www.templeofgood.com/xuezhe.asp" target="_blank" rel="noopener noreferrer">Rule<!--学者会学规--></a></li>
            <li>
              <router-link to="/useraddnew">Share<!--您的分享--></router-link>
            </li>  <!-- /useraddnew -->
            <li><a href="http://www.bolaaw.com" target="_blank" rel="noopener noreferrer">About Us<!--关于我们--></a></li>
          </ul>
        </div>

        <div id="content3">
          <img src='/images/web_img/vivo.jpg' alt="">
        </div>

        <content4newsbox></content4newsbox>

        <div id="content5">
          <img src='/images/web_img/manbuzhe.jpg' alt="">
        </div>

        <content6newsbox></content6newsbox>
        <div id="content7">
          <img src='/images/web_img/footer.jpg' alt="">
        </div>
      </div>

      <div id="rightPart">
        <!-- 顶部公益广告位（替代原分享图+视频） -->
        <img src='/images/web_img/harmony.jpg' alt="" class="ad-330">

        <div class="slogon12">
          <!--
            <p>中国古代哲学家说：</p>
            <p>想在天下弘扬光明正大品德的人；</p>
            <p>先要使自己获得知识；</p>
            <p>获得知识的途径在于认识、研究万事万物。</p>
            <p>通过对万事万物的认识、研究后才能获得知识；</p>
            <p>获得知识后意念才能真诚；</p>
            <p>意念真诚后心思才能端正；</p>
            <p>心思端正后才能修养品性；</p>
            <p>品性修养后才能管理好家庭和家族；</p>
            <p>管理好家庭和家族后才有好的国家；</p>
            <p>天下才能太平。</p>
            <p>（参考百度百科）</p>
           -->
        </div>

        <!-- 公益广告位：三种规格 220x220 / 220x330 / 220x440，与左栏内容底部对齐 -->
        <img src='/images/web_img/party.jpg' alt="" class="ad-440">
        <img src='/images/web_img/elephant.jpg' alt="" class="ad-440">
        <img src='/images/web_img/earth.jpg' alt="" class="ad-220">
        <img src='/images/web_img/planting.jpg' alt="" class="ad-220">
        <img src='/images/web_img/charity.jpg' alt="" class="ad-220">

        <div class="contactus">
          <a href="http://www.bolaaw.com" target="_blank" rel="noopener noreferrer"><img src='/images/web_img/BMA.jpg' alt=""></a>
          <p><b>E_Mail:</b> customer@bolaaw.com</p>
          <p><b>Address: </b></p>
          <p></p> <!-- 香港沙田火炭49－51號坳背灣街協力工業大廈7樓7室-->
          <p><b>Telephone：</b></p>
          <p>852-35010694</p>
          <img src='/images/web_img/d_pic.jpg' alt="">
        </div>
      </div>

      <pageFooter></pageFooter>
    </div>
  </div>
</template>

<!--<script src="http://www.templeofgood.com/TJ/sjmp5_LLFenxi.js" type="text/javascript" ></script> -->
<script>
import pageFooter from "@/components/Footer";
import content4newsbox from "@/components/Index/Content4NewsBox";
import content6newsbox from "@/components/Index/Content6NewsBox";
import clock from "@/mixins/clock";

export default {
  components: {
    pageFooter,
    content4newsbox,
    content6newsbox,
  },

  mixins: [clock],

  data() {
    return {
    }
  },

  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin manyLine6 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}

@mixin manyLine5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

@mixin manyLine4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

@mixin manyLine3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

#index {
  width: 100%;
  height: 100%;

  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
    cursor: pointer;
  }

  background-color: white;

  #containerBox {
    width: 1260px;

    background-color: #ccc;

    margin: 0 auto 0 auto;

    #header1 {
      width: 1212px;
      height: 15px;

      padding: 15px 11px 15px 11px;

      div {
        float: left;
      }
    }

    #leftPart {
      width: 1000px;

      float: left;
      margin: 0 6px 0 11px;
      // background-color: aqua;
      background-color: white;

      #content1 {
        height: 71px;
        background-color: white;

        img {
          float: left;
        }
      }

      #content2 {
        width: 1000px;
        height: 43px;

        margin-top: 10px;

        ul {
          width: 1000px;
          height: 43px;

          li {
            width: 200px;
            height: 43px;

            float: left;

            a {
              width: 200px;
              height: 43px;
              display: inline-block;
              background: url(../assets/leftpart/content2/hongse.jpg) no-repeat center;
              background-size: 200px 43px;
              color: white;
              padding-top: 10px;
              text-align: center;
            }
          }
        }
      }

      #content3 {
        img {
          width: 1000px;
          height: 250px;
          margin-top: 10px;
        }
      }

      #content5 {

        img {
          width: 1000px;
          height: 102px;
          object-fit: cover;
          margin: 10px 0 10px 0;
        }
      }

      #content7 {
        width: 1000px;

        img {
          width: 1000px;
          height: 180px;
          object-fit: cover;
          margin-top: 10px;
        }
      }
    }

    #rightPart {
      width: 230px;

      float: left;

      background-color: white;

      .slogon12 {
        background-color: white;

        p {
          font-size: 13px;
          text-align: left;

          margin-top: 8px;
          padding: 0 5px 0 5px;
        }
      }

      /* 三种公益广告规格：220x220 / 220x330 / 220x440，浅灰卡片底 */
      .ad-220, .ad-330, .ad-440 {
        background: #f5f5f5;
        padding: 6px;
        box-sizing: border-box;
        border: none;
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
      }
      .ad-220 {
        width: 220px;
        height: 220px;
        object-fit: cover;
        margin: 12px 5px 0 5px;
      }
      .ad-330 {
        width: 220px;
        height: 330px;
        object-fit: cover;
        margin: 12px 5px 0 5px;
      }
      .ad-440 {
        width: 220px;
        height: 440px;
        object-fit: cover;
        margin: 12px 5px 0 5px;
      }

      .contactus {
        width: 220px;
        margin: 5px 5px 0 5px;
        border-top: 1px solid #ccc;

        img:nth-child(1) {
          width: 220px;
        }

        p {
          text-align: left;
          font-size: 13px;
          margin: 8px 10px 0 10px;
        }

        img:nth-child(7) {
          width: 100px;
          position: relative;
          right: -65px;
          top: -70px;
        }
      }

    }
  }
}
</style>